/*
 * Home Questions — accordion behavior with smooth height animation.
 * Unified markup: every row is .qrow with .qrow-head (always visible)
 * and .qcard-body (collapsible). Open state = .is-open class.
 * CSS handles the height/opacity transition via max-height of .qcard-body__inner.
 *
 * Theme Editor support: re-binds when the section is re-rendered on
 * `shopify:section:load`. Uses a dataset flag to keep bindRows() idempotent.
 */
(function () {
  function setOpen(row, isOpen) {
    row.classList.toggle('is-open', isOpen);
    var toggle = row.querySelector('.qrow-toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Collapse' : 'Expand');
    }
  }

  function bindRow(row) {
    if (row.dataset.bound === '1') return;

    var head = row.querySelector('.qrow-head');
    if (!head) return;

    row.dataset.bound = '1';

    function handle(e) {
      // Ignore clicks on inner links/buttons inside the body
      if (e.target.closest('a, .qcard-body button, .qcard-body a')) return;
      // The toggle button itself works either way; head is also clickable
      setOpen(row, !row.classList.contains('is-open'));
    }

    head.addEventListener('click', handle);
    // Keyboard support
    head.setAttribute('tabindex', '0');
    head.setAttribute('role', 'button');
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setOpen(row, !row.classList.contains('is-open'));
      }
    });
  }

  function bindRows(scope) {
    var root = scope || document;
    // If scope is itself the .home-questions container we can just use it,
    // otherwise look inside the scope for any matching containers.
    var containers;
    if (root.classList && root.classList.contains('home-questions')) {
      containers = [root];
    } else {
      containers = root.querySelectorAll('.home-questions');
    }

    containers.forEach(function (container) {
      container.querySelectorAll('.qrow').forEach(bindRow);
    });
  }

  bindRows(document);

  // Theme Editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    bindRows(e.target);
  });
})();
